var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 25479"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 586",
    cx: 12,
    cy: 12,
    r: 12,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M15.8 7.90909H14.6V7.30303C14.6 7.13636 14.465 7 14.3 7C14.135 7 14 7.13636 14 7.30303V7.90909H8V7.30303C8 7.13636 7.865 7 7.7 7C7.535 7 7.4 7.13636 7.4 7.30303V7.90909H6.2C5.54 7.90909 5 8.45455 5 9.12121V15.7879C5 16.4545 5.54 17 6.2 17H15.8C16.46 17 17 16.4545 17 15.7879V9.12121C17 8.45455 16.46 7.90909 15.8 7.90909ZM16.4 15.7879C16.4 16.1212 16.13 16.3939 15.8 16.3939H6.2C5.87 16.3939 5.6 16.1212 5.6 15.7879V11.2424H16.4V15.7879ZM16.4 10.6364H5.6V9.12121C5.6 8.78788 5.87 8.51515 6.2 8.51515H7.4V9.42424C7.4 9.59091 7.535 9.72727 7.7 9.72727C7.865 9.72727 8 9.59091 8 9.42424V8.51515H14V9.42424C14 9.59091 14.135 9.72727 14.3 9.72727C14.465 9.72727 14.6 9.59091 14.6 9.42424V8.51515H15.8C16.13 8.51515 16.4 8.78788 16.4 9.12121V10.6364Z",
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.af0cd6d563389c8798e3217a306c7490.svg";
export { ForwardRef as ReactComponent };